<template>
<div>
   <div id="map" :style="{ height: '500px', width: '100%' }"></div>
</div>
</template>

<script>
import {pcaa} from 'area-data-vue';
import { BMPGL } from '@/bmpgl.js'
export default {
  data () {
    return {
      ak: 'stQ9hqOHuBSQhnM84GlZRGFQgicYcdDf',
      BMapGL: null,
      chart: null,
      total: 10000,
      mapList: [],
      option: {
        tooltip: {
          trigger: 'item'
        },
        bmap: {
          center: [104.114129, 30.550339],
          zoom: 4,
          roam: true,
          mapStyle: {
            styleJson: [
              {
                featureType: 'water',
                elementType: 'all',
                stylers: {
                  color: '#044161'
                }
              },
              {
                featureType: 'land',
                elementType: 'all',
                stylers: {
                  color: '#004981'
                }
              },
              {
                featureType: 'boundary',
                elementType: 'geometry',
                stylers: {
                  color: '#064f85'
                }
              },
              {
                featureType: 'railway',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'highway',
                elementType: 'geometry',
                stylers: {
                  color: '#004981'
                }
              },
              {
                featureType: 'highway',
                elementType: 'geometry.fill',
                stylers: {
                  color: '#005b96',
                  lightness: 1
                }
              },
              {
                featureType: 'highway',
                elementType: 'labels',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'geometry',
                stylers: {
                  color: '#004981'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'geometry.fill',
                stylers: {
                  color: '#00508b'
                }
              },
              {
                featureType: 'poi',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'green',
                elementType: 'all',
                stylers: {
                  color: '#056197',
                  visibility: 'off'
                }
              },
              {
                featureType: 'subway',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'manmade',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'local',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'labels',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'boundary',
                elementType: 'geometry.fill',
                stylers: {
                  color: '#029fd4'
                }
              },
              {
                featureType: 'building',
                elementType: 'all',
                stylers: {
                  color: '#1a5787'
                }
              },
              {
                featureType: 'label',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              }
            ]
          }
        },
        series: [
          {
            name: '数量',
            type: 'scatter',
            coordinateSystem: 'bmap',
            data: [],
            encode: {
              value: 2
            },
            symbolSize: function (val) {
              return val[2] + 10;
            },
            label: {
              formatter: '{b}',
              position: 'right'
            },
            itemStyle: {
              color: '#ddb926'
            },
            emphasis: {
              label: {
                show: true
              }
            }
          }
        ]
      },
      pcaa: pcaa,
      mapData: []
    }
  },
  created () {
  },
  mounted () {
    this.chart = echarts.init(document.getElementById('map'));
    this.chart.showLoading({maskColor: '#03050C'});
    this.initMap();
  },
  methods: {
    fetchCountData () {
      this.post('/dataapi/open/nqi/fruit/countByZone').then(res => {
        this.mapList = []
        this.total = res.result.length;
        for (let index in res.result) {
          if (res.result[index].city) {
            this.convertAddr(res.result[index])
          } else {
            this.total--;
          }
        }
      });
    },
    /**
     * {city, rs}
     */
    convertAddr (obj) {
      let city = obj.city.substring(0, 4) + '00';
      let name = this.pcaa[city][obj.city];
      return this.getLocationPoint(name, obj.rs)
    },
    initMap () {
      const _self = this;
      BMPGL(this.ak).then((BMapGL) => {
        _self.BMapGL = BMapGL;
        _self.fetchCountData()
      }).catch((err) => {
        console.log(err)
      })
    },
    getLocationPoint (address, count) {
      const _self = this;
      let BMapGL = this.BMapGL;
      let myGeo = new BMapGL.Geocoder();
      myGeo.getPoint(address, function (point) {
        _self.mapList.push({name: address, value: [point.lng, point.lat, count]});
        if (_self.mapList.length === _self.total) {
          _self.option.series[0].data = _self.mapList
          // 创建地图实例
          _self.chart.setOption(_self.option);
          _self.chart.hideLoading()
        }
      }, '')
    }
  }
}
</script>

<style lang="less">
.BMap_cpyCtrl ,.anchorBL{
    display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mapCount.vue